export default __webpack_public_path__ + "static/media/pirate-ship-2.4cd5989c.png";